<template>
  <div class="search-ingredients form-row">
    <b-form
      class="navbar-search form-inline mr-sm-3"
      @submit.prevent=""
    >
    <b-form-group class="mb-0">
      <b-input-group class="input-group-alternative input-group-merge">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="fas fa-search"></i></span>
        </div>
        <b-form-input 
        placeholder="Search" 
        type="text" 
        autocomplete="off" 
        class="js-header-search" 
        value="searchQuery" 
        v-model="searchQuery" 
        @keyup.enter="checkEnter"
        @focus.native="searchModalVisible = true"> </b-form-input>
      </b-input-group>
    </b-form-group>

    <div class="navbar-search__autocomplete" v-show="loading">
      <ul>
        <li @click.prevent="">
          Searching for {{ searchQuery }}<loading-panel></loading-panel>
        </li>
      </ul>
    </div>

    <div class="navbar-search__autocomplete" v-if="filteredResults.length && searchModalVisible">
      <ul v-show="!loading">
        <li v-for="(filteredResult, index) in filteredResults" :key="index" :data-id="filteredResult.id" @click="setResult(filteredResult)">
          {{ filteredResult.description}}
        </li>
      </ul>
    </div>
    </b-form>
  </div>
</template>
<script>
import LoadingPanel from '@/components/LoadingPanel.vue';
export default {
  name: "SearchIngredients",
  components: {
    LoadingPanel
  },
  data() {
    return {
      searchQuery: this.$route.query.search,
      searchModalVisible: false,
      ingredient: null,
      savedIngredient: [],
      data: null,
      pauseSearch: false,
      loading: false,
      searchUSDA: false,
      searchDataTypes: []
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    apiKey() {
      return this.data && this.data.api_key;
    },
    isLoading() {
      return this.$store.getters.ingredientsLoading
    },
    filteredResults() {
      return Object.values(this.$store.state.ingredients.searchResults)
    }
  },
  methods: {
    setResult(result) {
      this.ingredientName = result.title;
      this.searchQuery = '';
      this.searchModalVisible = false;
      this.ingredient = result;
      this.$emit("newIngredient", result);
    },
    searchIngredients() {
      if ( !this.searchQuery || this.searchQuery.length < 3 ) {return}
      
      const { dispatch } = this.$store;
      const searchArray = this.searchQuery.split(":");

      if ( searchArray && searchArray[0] == 'w' ) {
        dispatch("ingredients/getIngredientsQuickSearch",{
          "query": searchArray[1].trim(),
          "filter": "I",
          "dataTypes": ['whipstir']
        });
      } else if ( searchArray && searchArray[0] == 'f' ) {
        dispatch("ingredients/getIngredientsQuickSearch",{
          "query": searchArray[1].trim(),
          "filter": "I",
          "dataTypes": ['foundation_food']
        });
      } else if ( searchArray && searchArray[0] == 'b' ) {
        dispatch("ingredients/getIngredientsQuickSearch",{
          "query": searchArray[1].trim(),
          "filter": "I",
          "dataTypes": ['branded_food']
        });
      } else {
        dispatch("ingredients/getIngredientsQuickSearch",{
          "searchTerm": this.searchQuery
        });
      }
    },
    checkEnter(event) {
      if (event.keyCode === 13) {
        event.preventDefault();

        if (event.target.value.length) {
          this.searchQuery = event.target.value;
          var ingredient = { description: this.searchQuery };
          this.setResult(ingredient);
        }
      }
    }
  },
  mounted() {
    let _this = this;

    document.addEventListener('click', function(event) {
      let target = event.target;

      if (!target.classList.contains('js-header-search')) {
        _this.searchModalVisible = false;
      }
    });
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    searchQuery: function (val,old) {
      this.searchQuery = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchIngredients();
            this.pauseSearch = false;
          }, 1000); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
}
</script>
<style scoped>
.search-ingredients{
  margin-bottom: 40px;
}
</style>